module.exports = __webpack_public_path__ + "static/media/img-goal-2.be7966cb.jpg";